import { tm } from '../tm'
import type { CSSProperties } from 'react'
import './Spinner.css'

const SIZES = {
  small: 'w-5 h-5',
  medium: 'w-10 h-10',
  big: 'w-16 h-16',
}

interface SpinnerProps {
  className?: string
  size?: keyof typeof SIZES
  style?: CSSProperties
  light?: boolean
}

const emptyObject = {}
export function Spinner({
  className = '',
  size = 'small',
  light = false,
  style = emptyObject,
}: SpinnerProps) {
  return (
    <span
      style={{ borderLeftStyle: 'solid', ...style }}
      className={tm(
        'spinner-animation block rounded-[50%] border-double border-current',
        SIZES[size],
        className,
        light ? 'border-[3px]' : 'border-[5px]',
      )}
    />
  )
}
